import { Component, Input } from '@angular/core';
import { Router, RouterLink } from '@angular/router';

import { TranslatePipe } from '@ngx-translate/core';
@Component({
    selector: 'app-system-features',
        standalone: true,
imports: [RouterLink,
        TranslatePipe
    ],
    templateUrl: './system-features.component.html',
    styleUrl: './system-features.component.scss'
})
export class SystemFeaturesComponent {
  @Input() translations: any;

  constructor(private router: Router) {}
  navigateTo(route: string): void {
    this.router.navigate([route]);
  }
}
